import { render, staticRenderFns } from "./WoSummary.vue?vue&type=template&id=5cf66fd2&scoped=true"
import script from "./WoSummary.vue?vue&type=script&lang=js"
export * from "./WoSummary.vue?vue&type=script&lang=js"
import style0 from "./WoSummary.vue?vue&type=style&index=0&id=5cf66fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf66fd2",
  null
  
)

export default component.exports